import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { BackendApiError } from '@/lib/api/exception.ts';
import { TransportConfigurationWebDto } from '@/features/dashboard/tourTransport/types/TransportConfigurationDto.ts';

const transportApi = {
  /**
   * Returns null when the tour has no transport configuration yet
   * (404 TRANSPORT_CONFIGURATION_NOT_FOUND for newly-created tours).
   */
  get: async (tourId: string): Promise<TransportConfigurationWebDto | null> => {
    try {
      return await fetchPrivateApi<TransportConfigurationWebDto>(
        'GET',
        `tours/${tourId}/transport`,
      );
    } catch (error) {
      if (error instanceof BackendApiError && error.statusCode === 404) {
        return null;
      }
      throw error;
    }
  },
  put: async (
    tourId: string,
    dto: TransportConfigurationWebDto,
  ): Promise<TransportConfigurationWebDto> => {
    return await fetchPrivateApi<TransportConfigurationWebDto>(
      'PUT',
      `tours/${tourId}/transport`,
      dto,
    );
  },
};

export default transportApi;
